import React from 'react'
import {motion} from 'framer-motion'

const logoVariant={
	hidden:{
		rotate:"-180deg",
		opacity:0
	},
	visible:{
		opacity:1,
		rotate:"0deg",
		transition:{
			duration:0.8,
			ease:"easeInOut"
		}
	}
}
export default function Header() {
	return (
		<>
			<div className="header">
				<motion.div className="logo" variants={logoVariant} initial="hidden" animate="visible" >
					G
				</motion.div>
				<motion.div initial={{y:-250}} animate={{y:-10}} transition={{delay:0.2,type:"spring",stiffness:120,duration:0.5}} className="headline">
					<h4>Sky resume</h4>
				</motion.div>
			</div>
		</>
	)
}